import {
  Backdrop,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { FC } from "react";

type AuthContainerProps = {
  children: React.ReactNode;
  loading?: boolean;
  loadingText?: string;
};

export const AuthContainer: FC<AuthContainerProps> = ({
  children,
  loading = false,
  loadingText = "Loading...",
}) => {
  return (
    <>
      <Card
        raised
        sx={{
          maxWidth: {
            sm: 400,
            xs: "100%",
          },
          height: { xs: "100vh", sm: "100%" },
          margin: "0 auto",
          padding: { sm: "1em", xs: 0 },
          marginTop: { sm: "3em", sx: "1em" },
          overflow: "auto",
        }}
      >
        <CardMedia
          component="img"
          height="250"
          alt={"alt"}
          sx={{
            objectFit: "contain",
            maxWidth: { sm: "calc(400px - 2em)", xs: 300 },
            margin: "0 auto",
            px: 1,
          }}
          image="/images/logo.png"
        />
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          {children}
        </CardContent>
      </Card>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Stack direction="column" alignItems="center">
          <CircularProgress color="inherit" />
          <Typography variant="subtitle2" noWrap>
            {loadingText}
          </Typography>
        </Stack>
      </Backdrop>
    </>
  );
};
